import {React, useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import {Box, Paper, Grid, Stack, FormControl, InputLabel, MenuItem, Typography, Select, FormHelperText, TextField, Button, } from '@mui/material';
import {ArrowForwardIos, PersonAddAlt1} from '@mui/icons-material';
import axios from 'axios';
import { getMonthList } from '../../services/monthList';
import { getYearList } from '../../services/yearList';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import AddEmpDeductionComponent from './AddEmpDeductionComponent';
import Popup from '../Popup';

// const options = employeeService.getDepartmentCollection();
const monthOptions = getMonthList();
const yearOptions = getYearList();

const initialFValues = {
    id: 0,
    earningType: '',
    month: '',
    year: '',
    amount: '',
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const AddEmpEarningComponent = (props) => {

  const [earningTypes, setEarningTypes] = useState([]);
  // Initialize state with the initialFValues object to prevent errors
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
      if (notify.isOpen && notify.type === 'success') {
        // Close the modal after a short delay to show the notification
        const timer = setTimeout(() => {
          // Call the parent's function to close the modal
          if (props.onCloseModal) {
            props.onCloseModal();
          }
        }, 100);
        
        return () => clearTimeout(timer);
      }
    }, [notify, props.onCloseModal]);

  useEffect(() => {
    async function getEarningTypes() {
      try {
        // Corrected API URL syntax with proper template literal formatting
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/employee-master/get-earning-types`);
        setEarningTypes(response.data);
        
      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
    }
    getEarningTypes();
  }, []);

    


    const validate = () => {
        let temp = {};
        temp.amount = values.amount ? "" : "This field is required!";
        // Use strict comparison for a more robust check
        temp.earningType = values.earningType.length !== 0 ? "" : "This field is required!";

        setErrors({
            ...temp
        });

        return Object.values(temp).every(x => x === "");
    }

    const resetForm = () => {
        setValues(initialFValues);
        setErrors({});       
    }

    function handleInputChange(event) {
        const {name, value} = event.target;
        setValues({
            ...values,
            [name]: value      //overwrite name property.
        });
        if (errors[name]) {
          setErrors({
              ...errors,
              [name]: ''
          });
      }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // Only submit if the form is valid
        if(validate()){
            let API_URL = '';
            if(props.fetch_id === 9999) {
              // Corrected API URL syntax with proper template literal formatting
              API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/add-earning/` + props.employeeID;
            } else {
              // Corrected API URL syntax with proper template literal formatting
              API_URL =`${process.env.REACT_APP_API_BASE_URL}/employee-master/add-earning/` + props.fetch_id;
            }
            axios.post(API_URL, values)
            .then((response) => {
              if(response.status === 200) {
                setNotify({
                  isOpen: true,
                  message: 'Successfully added',
                  type: 'success'
                });
                dispatch(updateTableActions.startUpdateEmpEarningComponents());
              }
            })
            .catch((e) => {
              if(e.response.status === 401) {
                setNotify({
                  isOpen: true,
                  message: 'Session Expired!',
                  type: 'error'
                });
                setTimeout(() => {
                  navigate('/');
                },1000);
          }
        });
        }
    }
    
    return(
        <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px",marginTop: "-30px", padding: "50px", fontWeight: "500px"}}>
          <Paper elevation={2} sx={{width: "500px"}}>
            <Grid className="form-title" container spacing={2}>
              <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>ADD EMPLOYEE EARNING COMPONENT</Typography> </Grid>
              <Grid item> <PersonAddAlt1 sx={{marginTop: "-50px",width: 45, height: 45}}/> </Grid>
            </Grid>
            <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
    
              <Stack spacing={2} sx={{margin: "30px"}}>


              <FormControl
                  variant="outlined"
                  
                  {...(errors.earningType && {error:true} )}>
                    <InputLabel><RequiredLabel label="Earning Type"></RequiredLabel></InputLabel>
                    <Select
                      label="Earning Type"
                      name="earningType"
                      size="small"
                      value={values.earningType}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          earningTypes.map(
                            item => (<MenuItem key={item.deduction_earning_id} value={item.deduction_earning_id}>{item.deduction_earning_type}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.earningType && <FormHelperText>{errors.earningType}</FormHelperText>}
                </FormControl>

                <FormControl
                  variant="outlined"
                  {...(errors.month && {error:true} )}>
                    <InputLabel>Month</InputLabel>
                    <Select
                      label="Month"
                      name="month"
                      size="small"
                      value={values.month}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          monthOptions.map(
                            item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.month && <FormHelperText>{errors.month}</FormHelperText>}
                </FormControl>

                <FormControl
                  variant="outlined"
                  {...(errors.year && {error:true} )}>
                    <InputLabel>Year</InputLabel>
                    <Select
                      label="Year"
                      name="year"
                      size="small"
                      value={values.year}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="">None</MenuItem>
                        {
                          yearOptions.map(
                            item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                          )
                        }
    
                    </Select>
                    { errors.year && <FormHelperText>{errors.year}</FormHelperText>}
                </FormControl>

                <TextField
                  variant="outlined"
                  
                  name="amount"
                  label={<RequiredLabel label="Amount" />}
                  size="small"
                  value={values.amount}
                  onChange={handleInputChange}
                  {...(errors.amount && {error:true, helperText: errors.amount} )}
                />               
    
                <Grid container className="form-btn-container">
                  <Grid item>
                  <Button variant="contained" disableElevation color="error" type="button" onClick={resetForm}>Reset</Button>
                  </Grid>
                  <Grid item>
                  <Button variant="contained" disableElevation color="success" type="submit">Submit</Button>
                  </Grid>
                </Grid>
                </Stack>
                <Stack className="end-align" >
                  <Button className="form-btn" variant="outlined" type="button" onClick={() => setOpenPopup(true)} endIcon={<ArrowForwardIos />} >Next</Button>
                </Stack>
            </form>     
            <Popup
            title="Company Bank Accounts Form"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <AddEmpDeductionComponent employeeID={props.employeeID} fetch_id={9999}/>
          </Popup>        
    
          </Paper>
          <Notification
            notify={notify}
            setNotify={setNotify} />
        </Box>
      )
}

export default AddEmpEarningComponent
